import { IconLock, IconVolumeOff } from "@tabler/icons-react";
import { Badge, Group, ListaControlesSkeleton, Paper, Stack, Switch, Text } from "@/components/ui";
import { useCambiarPreferencia, useMisPreferencias } from "../hooks/use-perfil-notificaciones";

const ETIQUETA_CANAL: Record<string, string> = {
  Email: "Correo",
  Campana: "Campana",
  WebPush: "Navegador",
  Sms: "SMS",
  WhatsApp: "WhatsApp",
  Telegram: "Telegram",
};

/**
 * Notificaciones que te pueden llegar (según tus roles y los flujos publicados) con opción de
 * silenciarlas. Las obligatorias aparecen bloqueadas (spec §3.4).
 */
export function CardPreferencias() {
  const { data, isLoading } = useMisPreferencias();
  const cambiar = useCambiarPreferencia();

  return (
    <Paper withBorder padding="lg">
      <Stack gap="sm">
        <Group gap="xs">
          <IconVolumeOff size={18} className="text-multiva-600" />
          <Text fw={600}>Qué notificaciones recibo</Text>
        </Group>
        <Text size="sm" c="dimmed">Apaga las que no quieras recibir. Las marcadas con candado son obligatorias.</Text>
        {isLoading ? (
          <ListaControlesSkeleton filas={4} conBorde etiqueta="Cargando notificaciones…" />
        ) : !data || data.length === 0 ? (
          <Text size="sm" c="dimmed">Por ahora no hay notificaciones configuradas que te lleguen.</Text>
        ) : (
          <ul className="divide-y divide-border rounded-md border border-border">
            {data.map((n) => (
              <li key={`${n.flujoId}:${n.notificacionClave}`} className="flex items-center justify-between gap-3 px-3 py-2">
                <div className="min-w-0">
                  <Group gap="xs">
                    <span className="text-sm font-medium">{n.notificacionNombre}</span>
                    <Badge size="xs" color="slate" uppercase={false}>{ETIQUETA_CANAL[n.canal] ?? n.canal}</Badge>
                    {n.obligatoria ? <IconLock size={13} className="text-muted-foreground" aria-label="Obligatoria" /> : null}
                  </Group>
                  <Text size="xs" c="dimmed" truncate>Al ocurrir: {n.eventos.join(", ")} · {n.flujoNombre}</Text>
                </div>
                <Switch
                  checked={!n.silenciada}
                  disabled={n.obligatoria || cambiar.isPending}
                  aria-label={n.silenciada ? "Activar" : "Silenciar"}
                  onCheckedChange={(recibir) =>
                    cambiar.mutate({ flujoId: n.flujoId, notificacionClave: n.notificacionClave, silenciada: !recibir })
                  }
                />
              </li>
            ))}
          </ul>
        )}
      </Stack>
    </Paper>
  );
}
